import WildAppResource from "./WildAppResource";

export const AGENT = 11010;
export const SELLER = 11020;

export const ALL = {
    AGENT,
    SELLER,
};

class LuOrderedByTypeAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-ordered-by-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/ordereds/bies/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }
}

export default LuOrderedByTypeAppResource;
